module.exports = __webpack_public_path__ + "media/goforajourney/img/marrakech-card-h-b6f7673d95eb90ae67dca0f93e943e17.webp";